import slideDown from '../utility/slide/slide-down'
import slideUp from '../utility/slide/slide-up'

const accordion = {
  el: {
    root: null as HTMLElement | null,
    items: null as NodeListOf<HTMLElement> | null,
  },
  async init() {
    this.el.root = document.querySelector('.accordion')
    this.el.items = document.querySelectorAll('.accordion__item')

    this.el.items.forEach((item) => {
      const trigger = item.querySelector<HTMLElement>('.accordion__trigger')

      if (trigger) {
        trigger.removeEventListener('click', (e: Event & { target: HTMLElement }) => {
          this.clickEvent(e, item)
        })
        trigger.addEventListener('click', (e: Event & { target: HTMLElement }) => {
          this.clickEvent(e, item)
        })
      }
    })
  },

  clickEvent(e: Event & { target: HTMLElement }, item) {
    e.stopImmediatePropagation()

    // Set disabled attribute to prevent multiple clicks.
    e.target.setAttribute('disabled', '')

    const body = e.target.parentElement.querySelector('.accordion__body') as HTMLElement

    if (!item.hasAttribute('open')) {
      // Animate the body down
      slideDown(body)
      e.target.parentElement.setAttribute('open', '')
    } else {
      // Prevent default behavior so that it doesn't close immediately without animating.
      e.preventDefault()

      // Animate the body up
      slideUp(body)

      // Delay the removal of the open attribute so that it doesn't close immediately without animating.
      setTimeout(() => {
        e.target.parentElement.removeAttribute('open')
      }, 400)
    }

    // Remove disabled attribute after animation is done
    setTimeout(() => {
      e.target.removeAttribute('disabled')
    }, 400)
    e.stopPropagation()
  },

  async reset(event: Event) {
    if (this.el.root) {
      this.el.items.forEach(async (item) => {
        if (item && item.hasAttribute('open')) {
          event.preventDefault()
          const body = item.querySelector('.accordion__body.co-el') as HTMLElement
          slideUp(body)
          item.removeAttribute('open')
        }
      })
    }
  },
}

export default accordion
